import React from 'react';
import Navigation from '@/components/Navigation';
import { PageHeading } from '@/components/ui/page-heading';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Building, Link } from 'lucide-react';
import OrganisationURLSettings from '@/components/admin/OrganisationURLSettings';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const OrganisationPage = () => {
  return (
    <Navigation>
      <div className="space-y-6">
        <PageHeading 
          title="Organisation" 
          description="Manage your organisation details and settings"
        />
        
        <Tabs defaultValue="urls" className="space-y-4">
          <TabsList>
            <TabsTrigger value="general" disabled>
              <Building className="h-4 w-4 mr-2" />
              General
            </TabsTrigger>
            <TabsTrigger value="urls">
              <Link className="h-4 w-4 mr-2" />
              Default URLs
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="general" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>Organisation Details</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="bg-muted/50 rounded-md p-8 flex items-center justify-center">
                  <p className="text-center text-muted-foreground">
                    Organisation management functionality will be implemented in a future update.
                  </p>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="urls" className="space-y-4">
            <OrganisationURLSettings />
          </TabsContent>
        </Tabs>
      </div>
    </Navigation>
  );
};

export default OrganisationPage;
